import React, { useEffect, useState } from "react";
import "./../Form.scss";
import "./RecebimentosBoletos.scss";
import { useHistory, useParams } from "react-router";
import service from "../../../services/campanhas";
import { get } from "../../../services/recebimentos";
import { get as getRemessa, post } from "../../../services/remessas";
import serviceItinerarios from "../../../services/itinerarios";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowAltCircleDown,
  faArrowLeft,
  faEnvelopeOpenText,
  faReceipt,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { sumValuesArray } from "../../../utils/utils";
import { actions as actionsSite } from "../../../redux/actions/site";
import { useDispatch } from "react-redux";
import { formatCurrency } from "../../../utils/Money";
import CheckBox from "../form/generics/CheckBox";
import { actions as actionSite } from "../../../redux/actions/site";
import TitleModule from "../../../components/title/TitleModule";
import CheckBoxSimples from "../form/generics/CheckBoxSimples";
import { date2Front } from "../../../utils/converts";
import { API_URL } from "../../../config/constants";

const RecebimentosBoletos = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [itinerarios, setItinerarios] = useState([]);
  const history = useHistory();
  const params = useParams();
  const [campanha, setCampanha] = useState({});
  const [valorBoleto, setValorBoleto] = useState(1.5);
  const [valorFrete, setValorFrete] = useState(0);
  const initialRecebimento = {
    catalogoCodigo: null,
    usuario: null,
    campanha: null,
    valor: 0,
    semVolume: false,
    obs: null,
  };
  const [recebimento, setRecebimento] = useState(initialRecebimento);
  const [recebimentos, setRecebimentos] = useState([]);
  const [remessas, setRemessas] = useState([]);
  const [recebimentosOrganizados, setRecebimentosOrganizados] = useState([]);
  const [remessasPorRevendedora, setRemessasPorRevendedora] = useState([]);

  const { register, handleSubmit, errors, setValue } = useForm();

  const onSubmit = () => {};

  const imprimirBoletosRemessa = (numeroRemessa) => {
    dispatch(
      actionsSite.setLoadingMsg("Carregando dados da remessa para impressão")
    );
    setTimeout(() => {
      dispatch(actionsSite.setLoadingMsg(""));
      openNewTab(API_URL + "remessas/boletos/" + numeroRemessa);
    }, 3000);
  };

  const imprimirArquivoRemessa = (numeroRemessa) => {
    dispatch(
      actionsSite.setLoadingMsg("Carregando dados da remessa para impressão")
    );
    setTimeout(() => {
      dispatch(actionsSite.setLoadingMsg(""));
      openNewTab(API_URL + "remessas/arquivo/" + numeroRemessa);
    }, 3000);
  };

  const openNewTab = (url) => {
    window.open(url);
  };

  const imprimirBoleto = (boleto) => {
    const ids = boleto.boletos.map(b=>b.idBoleto).join('-');

    dispatch(
      actionsSite.setLoadingMsg("Carregando dados do boleto para impressão")
    );
    setTimeout(() => {
      dispatch(actionsSite.setLoadingMsg(""));
      openNewTab(API_URL + "remessas/boleto/" + ids);
    }, 3000);
  };

  const saveRemessa = async () => {
    const remessa = [...recebimentosOrganizados]
      .filter((e) => e.selected)
      .map((e) => {
        const totalValores = e.catalogos.map((c) => c.valor);
        totalValores.push(e.usuario.taxaManuseio || 0);
        const obj = {
          usuario: {
            _id: e.usuario._id,
            cpf: e.usuario.cpf,
            diasPagamento: e.usuario.diasPagamento,
            nome: e.usuario.nome,
          },
          valor: sumValuesArray(totalValores),
        };
        return obj;
      });
    const body = {
      campanha: params.id,
      remessa,
    };

    body.remessa = body.remessa.sort((a,b)=>(a.usuario.nome.toUpperCase() > b.usuario.nome.toUpperCase())?1:-1);
    // console.log('body', JSON.stringify(body));
    dispatch(actionsSite.setLoadingMsg("Enviando dados..."));
    const res = await post(`save`, body);
    dispatch(actionsSite.setLoadingMsg(res.msg));
    setTimeout(() => {
      imprimirBoletosRemessa(res.numeroRemessa);
      carregadosDadosIniciais();
    }, 3000);
  };

  const organizaBoletosRemessa = (remessas) => {
    const newRemessas = [];

    for (let remessa of remessas) {
      const exist = newRemessas.find(
        (e) => e.numeroRemessa === remessa.numeroRemessa
      );
      if (exist) {
        exist.boletos.push(remessa);
      } else {
        newRemessas.push({
          numeroRemessa: remessa.numeroRemessa,
          boletos: [remessa],
        });
      }
    }
    return newRemessas;
  };

  const carregadosDadosIniciais = async () => {
    //const run = async () => {
    const { id } = params;
    const _itinerarios = serviceItinerarios.get(`?sort=ordem&active=true`);
    const _campanhaInicial = service.getById(id);
    const _recebimentosCampanha = get(`by-campanha/${id}`);
    const _remessasCampanha = getRemessa(`by-campanha/${id}`);
    const [
      _resItinerarios,
      campanhaInicial,
      recebimentosCampanha,
      remessasCampanha,
    ] = await Promise.all([
      _itinerarios,
      _campanhaInicial,
      _recebimentosCampanha,
      _remessasCampanha,
    ]);

    setItinerarios(
      _resItinerarios.rows.map((e) => {
        e.selected = false;
        return e;
      })
    );

    setCampanha(campanhaInicial);
    setValorBoleto(campanhaInicial.valorBoleto);
    setValorFrete(campanhaInicial.valorFrete);
    setRemessas(organizaBoletosRemessa(remessasCampanha));
    setRecebimentos(recebimentosCampanha);
    setLoading(false);
    //};
  };

  useEffect(() => {
    const run = async () => {
      await carregadosDadosIniciais();
    };
    run();
  }, [params.id]);

  const gerouRemessa = (usuario) => {
    for (let remessa of remessas) {
      const exist = remessa.boletos.find(
        (e) => e.usuario && e.usuario._id === usuario._id
      );
      if (exist) {
        return exist;
      }
    }

    return false;
  };

  useEffect(() => {
    const recebimentosOrg = [];
    for (let rec of recebimentos) {
      const existIndex = recebimentosOrg.findIndex(
        (r) => r.usuario._id === rec.usuario._id
      );
      const verificaGerouRemessa = gerouRemessa(rec.usuario);
      if (!verificaGerouRemessa) {
        if (existIndex !== -1) {
          recebimentosOrg[existIndex].catalogos.push({
            catalogoCodigo: rec.catalogoCodigo,
            valor: rec.valor,
            semVolume: rec.semVolume || false,
            obs: rec.obs || "",
            pedido: rec.pedido || null,
          });
        } else {
          recebimentosOrg.push({
            usuario: rec.usuario,
            catalogos: [
              {
                catalogoCodigo: rec.catalogoCodigo,
                valor: rec.valor,
                semVolume: rec.semVolume || false,
                obs: rec.obs || "",
                pedido: rec.pedido || null,
              },
            ],
          });
        }
      }
    }
    setRecebimentosOrganizados(
      recebimentosOrg
        .filter((r) => {
          if (
            r.usuario.itinerario &&
            !r.usuario.pagamentoAvista &&
            !r.usuario.pagamentoCartao &&
            !r.usuario.pagamentoFaturado
          ) {
            return true;
          }
          return false;
        })
        .map((v) => {
          v.selected = false;
          return v;
        })
    );
  }, [recebimentos]);

  useEffect(() => {
    const _remessasPorRevendedora = [...remessas].map(v => {
      const r = {...v};
      const boletos = [];
      for(const b of r.boletos) {
        const exist = boletos.find(e=>e?._id.toString() === b.usuario._id.toString());
        if (exist){
          exist.boletos.push(b)
        } else {
          const usuario = b.usuario;
          usuario.boletos = [b];
          boletos.push(usuario);
        }
      }
      r.boletos = boletos;

      return r;
    });
    setRemessasPorRevendedora(_remessasPorRevendedora);
  }, [remessas]);

  const renderLancamentosModal = (catalogo, recebimento) => {
    const valores = recebimento.catalogos.filter(
      (c) => c.catalogoCodigo === catalogo.codigo
    );
    return (
      <table
        className="lancamentosPorCatalogos"
        cellSpacing={0}
        cellPadding={0}
      >
        <thead>
          <tr>
            <td align="right">Sem volume</td>
            <td align="left">Obs</td>
            <td align="right">Valor</td>
            <td align="right">Ação</td>
          </tr>
        </thead>
        <tbody>
          {valores.map((valor, index) => {
            const indexRecebimento = recebimentos.findIndex((r) => {
              if (
                r.catalogoCodigo === valor.catalogoCodigo &&
                r.valor === valor.valor &&
                r.usuario._id === recebimento.usuario._id
              ) {
                return true;
              }
            });
            return (
              <tr key={index}>
                <td align="right">{valor.semVolume ? "Sim" : "Não"}</td>
                <td align="left" width={300}>
                  {!valor.pedido && (
                    <input
                      type="text"
                      onChange={(e) => {
                        const value = e.target.value;
                        mudaObsRecebimento(indexRecebimento, value);
                      }}
                      defaultValue={valor.obs}
                    />
                  )}
                  {valor.pedido && (
                    <div>
                      Pedido nº {valor.pedido.sequencia}{" "}
                      <a
                        className="verPedido"
                        href={`/painel/pedidos-venda/view/${valor.pedido._id}`}
                        rel="noreferrer noopener"
                        target={"_blank"}
                      >
                        ver pedido
                      </a>
                    </div>
                  )}
                </td>
                <td align="right">{formatCurrency(valor.valor)}</td>
                <td align="right">
                  {!valor.pedido && (
                    <button
                      className="delete"
                      onClick={() => {
                        modalConfirmaRecebimentoExclusao(
                          catalogo,
                          recebimento,
                          indexRecebimento
                        );
                      }}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr className="titulo">
            <td align="right" colSpan={3}>
              Total
            </td>
            <td></td>
          </tr>
          <tr>
            <td align="right" colSpan={3}>
              {formatCurrency(sumValuesArray(valores.map((v) => v.valor)))}
            </td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    );
  };

  const voltarModalEditaRecebimento = (params) => {
    modalEditaRecebimento(params.catalogo, params.recebimento);
  };

  const modalConfirmaRecebimentoExclusao = (
    catalogo,
    recebimento,
    indexRecebimento
  ) => {
    const configModal = {
      msg: "Confirma a exlusão do lançamento?",
      //component: renderLancamentosModal(catalogo, recebimento),
      title: `${recebimento.usuario.nome} - ${catalogo.nome}`,
      actions: [
        {
          label: "Sim",
          class: "azul",
          callback: excluirRecebimento,
          arg: { indexRecebimento },
        },
        {
          label: "Voltar",
          class: "cinza",
          callback: voltarModalEditaRecebimento,
          arg: { catalogo, recebimento },
        },
      ],
    };

    dispatch(actionSite.setModal(configModal));
  };

  const modalEditaRecebimento = (catalogo, recebimento) => {
    const configModal = {
      msg: "",
      component: renderLancamentosModal(catalogo, recebimento),
      title: `${recebimento.usuario.nome} - ${catalogo.nome}`,
    };

    dispatch(actionSite.setModal(configModal));
  };

  const excluirRecebimento = (params) => {
    const clone = [...recebimentos];
    clone.splice(params.indexRecebimento, 1);
    setRecebimentos(clone);
    dispatch(actionSite.setModal(null));
  };

  const mudaObsRecebimento = (indexRecebimento, value) => {
    const clone = [...recebimentos];
    clone[indexRecebimento].obs = value;
    setRecebimentos(clone);
  };

  const renderRevendedorasBoleto = () => {
    return recebimentosOrganizados
      .filter((r) => {
        if (
          r.usuario.itinerario &&
          !r.usuario.pagamentoAvista &&
          !r.usuario.pagamentoCartao &&
          !r.usuario.pagamentoFaturado
        ) {
          return true;
        }
        return false;
      })
      .map((r, index) => {
        const totalValores = r.catalogos.map((c) => c.valor);
        totalValores.push(r.usuario.taxaManuseio || 0);
        return (
          <tr key={index} className={r.selected ? "selected" : ""}>
            <td>
              <CheckBoxSimples
                value={r.usuario._id}
                checked={r.selected}
                callback={flagUsuarios}
                showIcon
                reload
              />
            </td>
            <td>{r.usuario.nome}</td>
            <td>{r.usuario.itinerario && r.usuario.itinerario.nome}</td>
            <td>
              {r.usuario.diasPagamento
                .sort((a, b) => (a > b ? 1 : -1))
                .join(", ")}
            </td>
            <td
              align="right"
              style={
                r.usuario.limite &&
                r.usuario.limite < sumValuesArray(totalValores)
                  ? { color: "red" }
                  : {}
              }
            >
              {formatCurrency(sumValuesArray(totalValores))}
            </td>
            <td></td>
          </tr>
        );
      });
  };

  const renderBotaoGerarRemessa = () => {
    return (
      <div className="form recebimento">
        <form
          onSubmit={handleSubmit(saveRemessa)}
          className="formModule branco RecebimentosBoletos"
        >
          <div className="acoes mt-10">
            <button
              type="button"
              className="salvar"
              onClick={() => saveRemessa()}
            >
              <FontAwesomeIcon icon={faArrowAltCircleDown} /> Gerar remessa e
              imprimir boletos
            </button>
          </div>
        </form>
      </div>
    );
  };

  const flagItinerarios = (value, checked) => {
    const clone = [...itinerarios];
    const obj = clone.find((e) => e._id === value);
    obj.selected = checked;
    setItinerarios(clone);

    const roClone = [...recebimentosOrganizados].map((e) => {
      if (e.usuario.itinerario._id === value) {
        e.selected = checked;
      }
      return e;
    });
    setRecebimentosOrganizados(roClone);
    // console.log(value, checked);
  };

  const flagUsuarios = (value, checked) => {
    const clone = [...recebimentosOrganizados];
    const obj = clone.find((e) => e.usuario._id === value);
    obj.selected = checked;
    setRecebimentosOrganizados(clone);
    // console.log(value, checked);
  };

  const renderOpcoesItinerarios = () => {
    return itinerarios.map((i, index) => (
      <CheckBox
        key={String(index)}
        label={i.nome}
        value={i._id}
        checked={i.selected}
        callback={flagItinerarios}
        showIcon
      />
    ));
  };

  const itinerarioSelecionado = (id) => {
    const obj = itinerarios.find((e) => e._id === id);
    return obj.selected;
  };

  const getVencimentos = (boleto) => {
    return boleto.boletos.map(b=>date2Front(b.vencimento)).join('<br>');
  }

  const getValores = (boleto) => {
    return boleto.boletos.map(b=>formatCurrency(b.valor)).join('<br>');
  }

  const getQtdBoletos = (remessa) => {
    return remessa.boletos.map(e=>e.boletos.length).reduce((a,v)=>a+v);
  }

  const getTotalBoletos = (remessas) => {
    const totais = [];
    for(const r of remessas){
      totais.push(getQtdBoletos(r));
    }

    return totais.reduce((a,v)=>a+v);
  }

  const renderRemessas = () => {
    return <>
    {remessasPorRevendedora.length > 0 && (

      <div className="formModule branco RecebimentosBoletos">
        <div className="break"></div>
        <h3 className="tituloEtapa mt-10" style={{fontSize:30, textTransform:'uppercase'}}>
          {remessasPorRevendedora.length} remessa(s) - {getTotalBoletos(remessasPorRevendedora)} boleto(s)
        </h3>
        <div className="break"></div>
      </div>
    )}

    {remessasPorRevendedora.map((remessa, index) => {
      return (
        <div key={index} className="formModule branco RecebimentosBoletos">
          <div className="break"></div>
          <h3 className="tituloEtapa mt-10">
            Remessa #{remessa.numeroRemessa} ({getQtdBoletos(remessa)} boletos)
          </h3>
          <div className="break"></div>
          <div className="acoes mt-10">
            <button
              type="button"
              className="imprimir"
              onClick={() => imprimirArquivoRemessa(remessa.numeroRemessa)}
            >
              <FontAwesomeIcon icon={faEnvelopeOpenText} /> Imprimir arquivo da
              remessa
            </button>
            <button
              type="button"
              className="salvar"
              onClick={() => imprimirBoletosRemessa(remessa.numeroRemessa)}
            >
              <FontAwesomeIcon icon={faReceipt} /> Imprimir todos boletos da
              remessa
            </button>
          </div>

          <div className="crudView" style={{ width: "100%" }}>
            <div className="gridView">
              <table
                cellPadding="0"
                cellSpacing="0"
                className="recebimentosGrid"
              >
                <thead>
                  <tr>
                    <td width={20}>#</td>
                    <td>Revendedora</td>
                    <td width={100}>Dia</td>
                    <td width={100}>Vencimento</td>
                    <td align="right" width={100}>
                      Total
                    </td>
                    <td width={150}></td>
                  </tr>
                </thead>
                <tbody>
                  {remessa.boletos.map((boleto, indexBoleto) => {
                    return (
                      <tr key={`${index}.${indexBoleto}`}>
                        <td>{indexBoleto + 1}</td>
                        <td>{boleto.nome}</td>
                        <td>{boleto.itinerario.nome}</td>
                        <td>
                          <span dangerouslySetInnerHTML={{__html:getVencimentos(boleto)}}></span>
                        </td>
                        <td align="right">
                          <span dangerouslySetInnerHTML={{__html:getValores(boleto)}}></span>
                        </td>
                        <td>
                          <button
                            type="button"
                            className="salvar"
                            onClick={() => imprimirBoleto(boleto)}
                          >
                            <FontAwesomeIcon icon={faReceipt} /> Boletos
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      );
    })}
    </>
  };

  const renderRemessasDisponiveis = () => {
    return (
      <>
        {recebimentosOrganizados.length > 0 && (
          <>
            <form className="formModule branco RecebimentosBoletos">
              <div className="break"></div>
              <h3 className="tituloEtapa mt-10">
                Disponíveis para gerar remessa
              </h3>
              <div className="break"></div>
              <div className="filtrosGrid">
                <div className={"fieldButton"}>{renderOpcoesItinerarios()}</div>
              </div>

              <div className="crudView" style={{ width: "100%" }}>
                <div className="gridView">
                  <table
                    cellPadding="0"
                    cellSpacing="0"
                    className="recebimentosGrid"
                  >
                    <thead>
                      <tr>
                        <td width={20}>#</td>
                        <td width={500}>Revendedora</td>
                        <td width={100}>Dia</td>
                        <td>Dia de pagamento</td>
                        <td align="right" width={100}>
                          Total
                        </td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>{renderRevendedorasBoleto()}</tbody>
                  </table>
                </div>
              </div>
            </form>

            {renderBotaoGerarRemessa()}
          </>
        )}
      </>
    );
  };

  return (
    <>
      {!loading && (
        <TitleModule
          titulo={`Recebimentos - Boletos e Remessa Campanha ${campanha.codigo}`}
        />
      )}
      {!loading && (
        <>
          <div className="form recebimento">
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="formModule branco RecebimentosBoletos"
            >
              <div className="acoes">
                <button
                  type="button"
                  className="cancelar"
                  onClick={() => history.push("/painel/recebimentos")}
                >
                  <FontAwesomeIcon icon={faArrowLeft} /> Voltar
                </button>
              </div>
              <div className="break"></div>
            </form>
          </div>

          {renderRemessas()}
          {renderRemessasDisponiveis()}

          {/* <textarea
          style={{ width: "100%", height: "100px" }}
          value={JSON.stringify(recebimentos)}
        ></textarea> */}
        </>
      )}
      {loading && "Carregando..."}
    </>
  );
};

export default RecebimentosBoletos;
